import { render, staticRenderFns } from "./register-login-form.vue?vue&type=template&id=8015252e&"
import script from "./register-login-form.vue?vue&type=script&lang=js&"
export * from "./register-login-form.vue?vue&type=script&lang=js&"
import style0 from "./register-login-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports